import api from '../index';

export const getTmdQuestionsRequest = () => {
  return api.get('/tmd/questions');
};

export const sendTmdAnswersRequest = (payload) => {
  return api.post('/tmd/answers', payload);
};
